<section class="hire-better-section">
  <div class="hb-header">
    <h2>{{ "companyHome.hireBetterTitle" | translate }}</h2>
    <p>{{ "companyHome.hireBetterSubtitle" | translate }}</p>
  </div>

  <div class="hb-content-wrapper">
    <div class="hb-left-col">
      <div class="hb-icon-wrapper">
        <i class="bi bi-camera-video-fill"></i>
      </div>

      <h3>{{ "companyHome.aiInterview" | translate }}</h3>

      <p class="hb-desc">
        {{ "companyHome.aiInterviewDesc" | translate }}
      </p>

      <ul class="hb-features-list">
        <li>
          <i class="bi bi-check-circle-fill"></i>
          {{ "companyHome.aiFeat1" | translate }}
        </li>
        <li>
          <i class="bi bi-check-circle-fill"></i>
          {{ "companyHome.aiFeat2" | translate }}
        </li>
        <li>
          <i class="bi bi-check-circle-fill"></i>
          {{ "companyHome.aiFeat3" | translate }}
        </li>
        <li>
          <i class="bi bi-check-circle-fill"></i>
          {{ "companyHome.aiFeat4" | translate }}
        </li>
      </ul>

      <a routerLink="/virtual-interview-company" class="hb-learn-more">
        {{ "companyHome.learnMore" | translate }} <span>&rarr;</span>
      </a>
    </div>

    <div class="hb-right-col">
      <img src="assets/img/Feature 1.png" alt="AI Virtual Interview Feature" class="hb-feature-img" />
    </div>
  </div>
</section>
